import { gql, useLazyQuery, useQuery } from '@apollo/client';
import { TEXT_FIELDS } from "../../fragments";
export const TEXT_READ_BY_RELATED = gql`
  ${TEXT_FIELDS}
  query textReadByRelated($relatedId: Long, $relatedObjectTypeId: Int) {
    text_readByRelated(relatedId: $relatedId, relatedObjectTypeId: $relatedObjectTypeId) {
      ...TextFields
    }
  }
`;
export const useTextReadByRelatedLazyQuery = options => {
  return useLazyQuery(TEXT_READ_BY_RELATED, options);
};
export const useTextReadByRelatedQuery = options => {
  return useQuery(TEXT_READ_BY_RELATED, options);
};